<div class="td-wb-star-rating"
     [title]="stars() + ('tdWb.starRating.STARS' | tdWbTranslate)">
  <span class="td-wb-vh"
        [innerHtml]="stars() + ('tdWb.starRating.STARS' | tdWbTranslate)"></span>
  @for (iconState of iconStates(); track iconState) {
    <div class="td-wb-star-rating__item"
         aria-hidden="true"
         [ngClass]="{ 'td-wb-star-rating__item--selected': iconState }">
      <td-wb-icon iconId="star-filled--small"
                  size="15" />
    </div>
  }
  @if (!stars()) {
    <div class="td-wb-right"
         [innerText]="'-\u2009-\u2009-'"></div>
  }
</div>

